module.exports = __webpack_public_path__ + "img/industrial.aba36449.png";